// Quick View Variant's Image Change
const DEBUG = {
    enabled: false, // Set to false to disable debug logging
    log: function(...args) {
      if (this.enabled) {
        console.log('[Quick Add Debug]', ...args);
      }
    },
    error: function(...args) {
      if (this.enabled) {
        console.error('[Quick Add Debug]', ...args);
      }
    }
  };
 
  function debounce(func, wait) {
     let timeout;
     return function executedFunction(...args) {
       const later = () => {
         clearTimeout(timeout);
         func(...args);
       };
       clearTimeout(timeout);
       timeout = setTimeout(later, wait);
     };
   }
 
   let cachedElements = {
     mainImage: null,
     variantContainer: null,
     variantJson: null
   };

   // Store the target variant ID and product handle to preselect
   let targetVariantId = null;
   let targetProductHandle = null;
   let targetColorValue = null; // Store color value as fallback
 
   function initializeGallery() {
     DEBUG.log('Initializing gallery...');
     
     const waitForElements = setInterval(() => {
       cachedElements.mainImage = document.querySelector('[data-gallery-image]');
       cachedElements.variantContainer = document.querySelector('[data-product-variants]');
       
       DEBUG.log('Checking for elements...');
       DEBUG.log('Main image element:', cachedElements.mainImage);
       DEBUG.log('Variant container:', cachedElements.variantContainer);
       
       if (cachedElements.mainImage && cachedElements.variantContainer) {
         clearInterval(waitForElements);
         DEBUG.log('Elements found, proceeding with initialization');
         setupGallery();
       }
     }, 100);
 
     setTimeout(() => {
       clearInterval(waitForElements);
     }, 5000);
   }

   function preselectVariant(variantId) {
     DEBUG.log('=== PRESELECT VARIANT START ===');
     DEBUG.log('Attempting to preselect variant:', variantId);
     DEBUG.log('Variant ID type:', typeof variantId);
     DEBUG.log('Variant ID value:', variantId);
     
     // Re-fetch variant JSON to ensure we have the latest data
     const variantJsonElement = document.querySelector('[data-variant-json]');
     if (variantJsonElement) {
       try {
         cachedElements.variantJson = JSON.parse(variantJsonElement.textContent);
         DEBUG.log('Re-parsed variant JSON:', cachedElements.variantJson);
       } catch (e) {
         DEBUG.error('Error re-parsing variant JSON:', e);
       }
     }
     
     if (!cachedElements.variantJson || !variantId) {
       DEBUG.log('No variant JSON or variant ID available for preselection');
       DEBUG.log('Variant JSON:', cachedElements.variantJson);
       DEBUG.log('Variant ID:', variantId);
       return;
     }

     // Convert variantId to string for comparison (variant IDs might be strings or numbers)
     const variantIdStr = String(variantId);
     const targetVariant = cachedElements.variantJson.find(variant => {
       const variantIdMatch = String(variant.id) === variantIdStr;
       DEBUG.log('Comparing variant ID:', variant.id, 'with target:', variantIdStr, 'match:', variantIdMatch);
       return variantIdMatch;
     });
     
     if (!targetVariant) {
       DEBUG.log('Target variant not found:', variantId);
       DEBUG.log('Available variants:', cachedElements.variantJson.map(v => ({ id: v.id, options: v.options })));
       return;
     }

     DEBUG.log('Found target variant:', targetVariant);
     
     // Debug DOM structure
     DEBUG.log('Current DOM structure:');
     DEBUG.log('- Product variants container:', document.querySelector('[data-product-variants]'));
     DEBUG.log('- All variant buttons:', document.querySelectorAll('[data-product-variants] button[data-option-value]'));
     DEBUG.log('- All swatch displays:', document.querySelectorAll('[data-swatch-selected]'));
     DEBUG.log('- All color swatch values:', document.querySelectorAll('.product__color-swatch-value'));

    // Update variant selections based on the target variant's options
    // First, set all option values WITHOUT triggering change events
    const optionInputs = [];
    targetVariant.options.forEach((optionValue, index) => {
      DEBUG.log(`Setting option ${index + 1} to: ${optionValue}`);
      
      // Handle select dropdowns - use more specific selectors
      const selectInput = document.querySelector(`[data-product-variants] select#option${index + 1}, [data-product-variants] select[name="options[${Object.keys(targetVariant.option_names || {})[index] || index}]"]`);
      if (selectInput) {
        selectInput.value = optionValue;
        optionInputs.push(selectInput); // Store for later change event
        DEBUG.log('Updated select input value (without triggering change):', selectInput);
      }

      // Handle button-based options (chips/swatches)
      const buttonSelector = `[data-product-variants] button[data-option-value="${optionValue}"]`;
      const targetButton = document.querySelector(buttonSelector);
      
      DEBUG.log('Button selector:', buttonSelector);
      DEBUG.log('Found target button:', targetButton);
      
      if (targetButton) {
        // Remove selected class from all buttons in the same option group
        const optionGroup = targetButton.closest('.product__option, .product__color-chips, [data-option-buttons]');
        DEBUG.log('Found option group:', optionGroup);
        
        if (optionGroup) {
          optionGroup.querySelectorAll('button').forEach(btn => btn.classList.remove('selected'));
          targetButton.classList.add('selected');
          
          // Update the color swatch value display text - try multiple selectors
          const swatchValueSelectors = [
            '[data-swatch-selected]',
            '.product__color-swatch-value',
            '.product__option-value',
            '.swatch-value'
          ];
          
          let swatchValueDisplay = null;
          for (const selector of swatchValueSelectors) {
            swatchValueDisplay = optionGroup.querySelector(selector);
            if (swatchValueDisplay) {
              DEBUG.log('Found swatch value display with selector:', selector, swatchValueDisplay);
              break;
            }
          }
          
          if (swatchValueDisplay) {
            const oldValue = swatchValueDisplay.textContent;
            swatchValueDisplay.textContent = optionValue;
            DEBUG.log('Updated swatch value display from:', oldValue, 'to:', optionValue);
          } else {
            DEBUG.log('No swatch value display found. Available elements in option group:', optionGroup.innerHTML);
          }
          
          // Also update the associated hidden select if it exists (but don't trigger change yet)
          const hiddenSelect = optionGroup.querySelector('select');
          if (hiddenSelect) {
            hiddenSelect.value = optionValue;
            if (!optionInputs.includes(hiddenSelect)) {
              optionInputs.push(hiddenSelect); // Store for later change event
            }
            DEBUG.log('Updated hidden select value (without triggering change):', hiddenSelect);
          }
          
          DEBUG.log('Selected button:', targetButton);
        }
      } else {
        DEBUG.log('No button found for option value:', optionValue);
        DEBUG.log('Available buttons:', document.querySelectorAll('[data-product-variants] button[data-option-value]'));
      }
    });
    
    // Now trigger change events for all inputs at once, after all options are set
    // This prevents theme.js from resetting options when we're still setting them
    if (optionInputs.length > 0) {
      DEBUG.log('Triggering change events for all option inputs:', optionInputs.length);
      // Use setTimeout to ensure all values are set before triggering change events
      setTimeout(() => {
        optionInputs.forEach(input => {
          DEBUG.log('Triggering change event for:', input);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }, 50); // Small delay to ensure all DOM updates are complete
    }

     // Update the main image if the variant has a featured image
     if (targetVariant.featured_image && cachedElements.mainImage) {
       let newImageSrc = targetVariant.featured_image.src;
       
       if (newImageSrc.includes('_500x')) {
         newImageSrc = newImageSrc.replace(/_500x/g, '_500x');
       } else {
         newImageSrc = newImageSrc.replace(/(\.[^.]+)$/, '_500x$1');
       }
       
       DEBUG.log('Updating main image to:', newImageSrc);
       
       const tempImage = new Image();
       tempImage.onload = function() {
         cachedElements.mainImage.src = newImageSrc;
         cachedElements.mainImage.alt = targetVariant.featured_image.alt || '';
       };
       tempImage.src = newImageSrc;
     }

     // Update the variant container with the current variant ID
     if (cachedElements.variantContainer) {
       cachedElements.variantContainer.setAttribute('data-current-variant-id', targetVariant.id);
       DEBUG.log('Updated variant container ID to:', targetVariant.id);
     }

     // Update any hidden variant ID inputs
     const variantIdInputs = document.querySelectorAll('input[name="id"], select[name="id"]');
     variantIdInputs.forEach(input => {
       input.value = targetVariant.id;
       DEBUG.log('Updated variant ID input:', input);
     });
     
     // Reset targetVariantId after successful preselection
     targetVariantId = null;
     
     DEBUG.log('=== PRESELECT VARIANT END ===');
   }

 
   function setupGallery() {
     const variantInputs = document.querySelectorAll('[data-product-variants] select, [data-product-variants] button');
     DEBUG.log('Found variant inputs:', variantInputs.length);
     if (variantInputs.length === 0) {
       DEBUG.log('No variant inputs found, returning');
       return;
     }

     // Always re-fetch variant JSON to ensure we have the correct product's data
     const variantJsonElement = document.querySelector('[data-variant-json]');
     if (variantJsonElement) {
       try {
         // Clear cached variant JSON and re-parse to get fresh data
         cachedElements.variantJson = null;
         cachedElements.variantJson = JSON.parse(variantJsonElement.textContent);
         DEBUG.log('Successfully parsed variant JSON:', cachedElements.variantJson);
         DEBUG.log('Variant JSON length:', cachedElements.variantJson ? cachedElements.variantJson.length : 0);
         
         // Preselect the target variant if specified
         DEBUG.log('Checking for target variant ID:', targetVariantId);
         if (targetVariantId) {
           // Check if the target variant ID exists in the current variant JSON
           const variantIdStr = String(targetVariantId);
           const variantExists = cachedElements.variantJson.some(variant => String(variant.id) === variantIdStr);
           
           if (variantExists) {
             DEBUG.log('Target variant ID found in current product, calling preselectVariant in 200ms...');
             // Use a longer delay to ensure the modal content is fully loaded
             setTimeout(() => {
               preselectVariant(targetVariantId);
               // Don't reset targetVariantId here - let it be reset after successful preselection
             }, 200);
           } else {
             DEBUG.log('Target variant ID not found in current product, trying fallback by color value...');
             DEBUG.log('Available variant IDs:', cachedElements.variantJson.map(v => v.id));
             DEBUG.log('Target variant ID:', targetVariantId);
             DEBUG.log('Target color value:', targetColorValue);
             
             // Fallback: Try to find variant by color value
             if (targetColorValue && cachedElements.variantJson && cachedElements.variantJson.length > 0) {
               DEBUG.log('⚠️ Trying fallback: Find variant by color value:', targetColorValue);
               
               // Find the color option position in the product
               let colorOptionPosition = null;
               const firstVariant = cachedElements.variantJson[0];
               if (firstVariant && firstVariant.options) {
                 // Try to find which option position matches the color value
                 for (let i = 0; i < firstVariant.options.length; i++) {
                   if (firstVariant.options[i] === targetColorValue) {
                     colorOptionPosition = i;
                     DEBUG.log('Found color option at position:', colorOptionPosition);
                     break;
                   }
                 }
               }
               
               // Find all variants with matching color
               const matchingVariants = cachedElements.variantJson.filter(variant => {
                 if (!variant.options || variant.options.length === 0) return false;
                 
                 // If we found the color option position, use it
                 if (colorOptionPosition !== null) {
                   return variant.options[colorOptionPosition] === targetColorValue;
                 }
                 
                 // Otherwise, check if any option matches the color value
                 return variant.options.includes(targetColorValue);
               });
               
               DEBUG.log('Found variants with matching color:', matchingVariants.length);
               DEBUG.log('Matching variants:', matchingVariants.map(v => ({
                 id: v.id,
                 available: v.available,
                 options: v.options
               })));
               
               if (matchingVariants.length > 0) {
                 // Prioritize available variants
                 const availableVariants = matchingVariants.filter(v => v.available);
                 const selectedVariant = availableVariants.length > 0 
                   ? availableVariants[0]  // Use first available variant
                   : matchingVariants[0];   // Fallback to first matching variant even if unavailable
                 
                 DEBUG.log('✅ Selected variant by color value:', selectedVariant.id);
                 DEBUG.log('Variant details:', {
                   id: selectedVariant.id,
                   available: selectedVariant.available,
                   options: selectedVariant.options,
                   title: selectedVariant.title
                 });
                 
                 setTimeout(() => {
                   preselectVariant(selectedVariant.id);
                 }, 200);
                 return; // Don't continue with retry logic
               } else {
                 DEBUG.log('❌ No variant found with color value:', targetColorValue);
                 DEBUG.log('Available variants:', cachedElements.variantJson.map(v => ({
                   id: v.id,
                   options: v.options
                 })));
               }
             }
             
             // Wait and retry - the modal might still be loading the correct product data
             let retryCount = 0;
             const maxRetries = 20; // Increase retries since modal content loads asynchronously
             const retryInterval = 150; // Slightly faster retry interval
             
             const checkAndPreselect = () => {
               retryCount++;
               DEBUG.log(`Retry ${retryCount}/${maxRetries}: Checking for variant JSON update...`);
               DEBUG.log('Target productHandle:', targetProductHandle || 'unknown');
               DEBUG.log('Target variant ID:', variantIdStr);
               
               // Check if modal content matches the target product
               let currentProductHandle = null;
               
               // Try multiple methods to get product handle from modal
               // Method 1: From data-product-handle attribute
               const productHandleElement = document.querySelector('[data-quick-add-modal] [data-product-handle]');
               if (productHandleElement) {
                 currentProductHandle = productHandleElement.getAttribute('data-product-handle');
                 DEBUG.log('Current product handle from data-product-handle:', currentProductHandle);
               }
               
               // Method 2: From product link href
               if (!currentProductHandle) {
                 const modalProductLink = document.querySelector('[data-quick-add-modal] a[href*="/products/"]');
                 if (modalProductLink) {
                   const hrefMatch = modalProductLink.href.match(/\/products\/([^\/\?]+)/);
                   if (hrefMatch) {
                     currentProductHandle = hrefMatch[1];
                     DEBUG.log('Current product handle from link:', currentProductHandle);
                   }
                 }
               }
               
               // Method 3: From form action
               if (!currentProductHandle) {
                 const productForm = document.querySelector('[data-quick-add-modal] form[action*="/cart/add"]');
                 if (productForm && productForm.action) {
                   const actionMatch = productForm.action.match(/\/products\/([^\/\?]+)/);
                   if (actionMatch) {
                     currentProductHandle = actionMatch[1];
                     DEBUG.log('Current product handle from form:', currentProductHandle);
                   }
                 }
               }
               
               // Method 4: From variant JSON element's data attribute
               if (!currentProductHandle) {
                 const variantJsonElement = document.querySelector('[data-quick-add-modal] [data-variant-json]');
                 if (variantJsonElement) {
                   const parent = variantJsonElement.closest('[data-product-handle]');
                   if (parent) {
                     currentProductHandle = parent.getAttribute('data-product-handle');
                     DEBUG.log('Current product handle from variant JSON parent:', currentProductHandle);
                   }
                 }
               }
               
               if (!currentProductHandle) {
                 DEBUG.log('Current product handle in modal: unknown');
               }
               
               const currentVariantJsonElement = document.querySelector('[data-variant-json]');
               if (currentVariantJsonElement) {
                 try {
                   const currentVariantJson = JSON.parse(currentVariantJsonElement.textContent);
                   const variantExists = currentVariantJson.some(variant => String(variant.id) === variantIdStr);
                   
                   // Also check if the variant JSON has changed (different product)
                   const currentVariantIds = currentVariantJson.map(v => String(v.id));
                   DEBUG.log('Current variant IDs in JSON (full list):', currentVariantIds);
                   DEBUG.log('Current variant IDs count:', currentVariantIds.length);
                   DEBUG.log('Target variant ID (string):', variantIdStr);
                   DEBUG.log('Target variant ID (original):', targetVariantId);
                   DEBUG.log('Target variant ID type:', typeof targetVariantId, typeof variantIdStr);
                   DEBUG.log('Variant ID match check:', currentVariantIds.map(id => ({
                     id: id,
                     matches: id === variantIdStr,
                     type: typeof id
                   })));
                   
                   // Check if product handle matches
                   if (currentProductHandle && targetProductHandle && currentProductHandle !== targetProductHandle) {
                     DEBUG.log('⚠️ Product handle mismatch!');
                     DEBUG.log('  Expected:', targetProductHandle);
                     DEBUG.log('  Found in modal:', currentProductHandle);
                     DEBUG.log('  This means the modal loaded the wrong product!');
                     // Continue retrying - the modal might still be loading the correct product
                   }
                   
                   if (variantExists) {
                     DEBUG.log('Target variant ID found after retry, calling preselectVariant...');
                     cachedElements.variantJson = currentVariantJson;
                     preselectVariant(targetVariantId);
                     return;
                   } else {
                     DEBUG.log('Target variant ID still not found in current product');
                     if (currentProductHandle && targetProductHandle && currentProductHandle !== targetProductHandle) {
                       DEBUG.log('⚠️ Product mismatch detected - modal shows wrong product!');
                     }
                     
                     // Fallback: Try to find variant by color value
                     if (targetColorValue && currentVariantJson && currentVariantJson.length > 0) {
                       DEBUG.log('⚠️ Trying fallback: Find variant by color value:', targetColorValue);
                       
                       // Find the color option position in the product
                       // We need to find which option is "Colour" or "Color"
                       let colorOptionPosition = null;
                       const firstVariant = currentVariantJson[0];
                       if (firstVariant && firstVariant.options) {
                         // Try to find which option position matches the color value
                         for (let i = 0; i < firstVariant.options.length; i++) {
                           if (firstVariant.options[i] === targetColorValue) {
                             colorOptionPosition = i;
                             DEBUG.log('Found color option at position:', colorOptionPosition);
                             break;
                           }
                         }
                       }
                       
                       // Find all variants with matching color
                       const matchingVariants = currentVariantJson.filter(variant => {
                         if (!variant.options || variant.options.length === 0) return false;
                         
                         // If we found the color option position, use it
                         if (colorOptionPosition !== null) {
                           return variant.options[colorOptionPosition] === targetColorValue;
                         }
                         
                         // Otherwise, check if any option matches the color value
                         return variant.options.includes(targetColorValue);
                       });
                       
                       DEBUG.log('Found variants with matching color:', matchingVariants.length);
                       DEBUG.log('Matching variants:', matchingVariants.map(v => ({
                         id: v.id,
                         available: v.available,
                         options: v.options
                       })));
                       
                       if (matchingVariants.length > 0) {
                         // Prioritize available variants
                         const availableVariants = matchingVariants.filter(v => v.available);
                         const selectedVariant = availableVariants.length > 0 
                           ? availableVariants[0]  // Use first available variant
                           : matchingVariants[0];   // Fallback to first matching variant even if unavailable
                         
                         DEBUG.log('✅ Selected variant by color value:', selectedVariant.id);
                         DEBUG.log('Variant details:', {
                           id: selectedVariant.id,
                           available: selectedVariant.available,
                           options: selectedVariant.options,
                           title: selectedVariant.title
                         });
                         
                         cachedElements.variantJson = currentVariantJson;
                         preselectVariant(selectedVariant.id);
                         return;
                       } else {
                         DEBUG.log('❌ No variant found with color value:', targetColorValue);
                         DEBUG.log('Available variants:', currentVariantJson.map(v => ({
                           id: v.id,
                           options: v.options
                         })));
                       }
                     }
                   }
                 } catch (e) {
                   DEBUG.error('Error parsing variant JSON during retry:', e);
                 }
               } else {
                 DEBUG.log('Variant JSON element not found yet');
               }
               
               if (retryCount < maxRetries) {
                 setTimeout(checkAndPreselect, retryInterval);
               } else {
                 DEBUG.error('Max retries reached, target variant ID not found in product data');
                 DEBUG.error('Target product handle:', targetProductHandle);
                 DEBUG.error('Current product handle in modal:', currentProductHandle || 'unknown');
                 DEBUG.error('This might mean the modal loaded the wrong product or the variant ID is incorrect');
                 targetVariantId = null; // Reset to prevent infinite retries
                 targetProductHandle = null;
               }
             };
             
             setTimeout(checkAndPreselect, retryInterval);
           }
         } else {
           DEBUG.log('No target variant ID found, skipping preselection');
         }
       } catch (e) {
         DEBUG.error('Error parsing variant JSON:', e);
         return;
       }
     } else {
       DEBUG.log('No variant JSON element found');
       // If variant JSON not found yet, wait a bit and try again
       if (targetVariantId) {
         DEBUG.log('Variant JSON not found, retrying in 200ms...');
         setTimeout(() => {
           setupGallery();
         }, 200);
       }
     }
 
     const updateVariant = debounce(function(selectedOptions) {
       DEBUG.log('Updating variant with options:', selectedOptions);
       if (!cachedElements.variantJson) {
         DEBUG.log('No variant JSON available');
         return;
       }
 
       const matchingVariant = cachedElements.variantJson.find(variant => {
         return variant.options.every((option, index) => {
           const optionName = Object.keys(selectedOptions)[index];
           return variant.options[index] === selectedOptions[optionName];
         });
       });
 
       DEBUG.log('Matching variant:', matchingVariant);
 
              if (matchingVariant) {
         if (cachedElements.variantContainer) {
           cachedElements.variantContainer.setAttribute('data-current-variant-id', matchingVariant.id);
           DEBUG.log('Updated variant container ID to:', matchingVariant.id);
         }

         // Update swatch value displays for all options
         matchingVariant.options.forEach((optionValue, index) => {
           DEBUG.log(`Updating swatch display for option ${index + 1}: ${optionValue}`);
           
           // Find the corresponding option group
           const optionGroups = document.querySelectorAll('[data-product-variants] .product__option');
           if (optionGroups[index]) {
             const optionGroup = optionGroups[index];
             
             // Try multiple selectors for swatch value display
             const swatchValueSelectors = [
               '[data-swatch-selected]',
               '.product__color-swatch-value',
               '.product__option-value',
               '.swatch-value'
             ];
             
             let swatchValueDisplay = null;
             for (const selector of swatchValueSelectors) {
               swatchValueDisplay = optionGroup.querySelector(selector);
               if (swatchValueDisplay) {
                 DEBUG.log('Found swatch value display with selector:', selector, swatchValueDisplay);
                 break;
               }
             }
             
             if (swatchValueDisplay) {
               const oldValue = swatchValueDisplay.textContent;
               swatchValueDisplay.textContent = optionValue;
               DEBUG.log('Updated swatch value display from:', oldValue, 'to:', optionValue);
             } else {
               DEBUG.log('No swatch value display found in option group:', optionGroup.innerHTML);
             }
           }
         });

         if (matchingVariant.featured_image) {
           const currentSrc = cachedElements.mainImage.src;
           let newImageSrc = matchingVariant.featured_image.src;
           
           DEBUG.log('Current image src:', currentSrc);
           DEBUG.log('New image src before processing:', newImageSrc);
           
           if (newImageSrc.includes('_500x')) {
             newImageSrc = newImageSrc.replace(/_500x/g, '_500x');
           } else {
             newImageSrc = newImageSrc.replace(/(\.[^.]+)$/, '_500x$1');
           }
           
           DEBUG.log('Processed new image src:', newImageSrc);
           
           if (currentSrc !== newImageSrc) {
             DEBUG.log('Image source will change');
             const tempImage = new Image();
             tempImage.onload = function() {
               DEBUG.log('New image loaded successfully');
               cachedElements.mainImage.src = newImageSrc;
               cachedElements.mainImage.alt = matchingVariant.featured_image.alt || '';
             };
             tempImage.onerror = function() {
               DEBUG.error('Failed to load new image:', newImageSrc);
             };
             tempImage.src = newImageSrc;
           } else {
             DEBUG.log('Image source unchanged');
           }
         } else {
           DEBUG.log('No featured image for this variant');
         }
       } else {
         DEBUG.log('No matching variant found');
       }
     }, 100);
 
    variantInputs.forEach(input => {
      input.addEventListener('change', function() {
        DEBUG.log('Variant input changed:', this);
        const selectedOptions = {};
        document.querySelectorAll('[data-product-variants] select, [data-product-variants] button[data-option-value]').forEach(input => {
          if (input.tagName === 'SELECT') {
            selectedOptions[input.name.replace('options[', '').replace(']', '')] = input.value;
          } else if (input.classList.contains('selected')) {
            const optionGroup = input.closest('.product__option');
            if (optionGroup) {
              const optionLabel = optionGroup.querySelector('.product__label');
              if (optionLabel) {
                const optionName = optionLabel.textContent.trim();
                selectedOptions[optionName] = input.getAttribute('data-option-value');
              }
            }
          }
        });
        DEBUG.log('Collected selected options:', selectedOptions);
        updateVariant(selectedOptions);
      });
    });
 
    const handleButtonClick = debounce(function(button) {
      DEBUG.log('Button clicked:', button);
      const optionGroup = button.closest('.product__option');
      
      // Add null check to prevent TypeError
      if (!optionGroup) {
        DEBUG.log('Warning: option group not found for button:', button);
        return;
      }
      
      optionGroup.querySelectorAll('button').forEach(btn => btn.classList.remove('selected'));
      button.classList.add('selected');
      
      const firstInput = optionGroup.querySelector('select');
      if (firstInput) {
        firstInput.value = button.getAttribute('data-option-value');
        DEBUG.log('Dispatching change event on select with value:', firstInput.value);
        firstInput.dispatchEvent(new Event('change'));
      }
    }, 100);
 
     document.querySelectorAll('[data-product-variants] button[data-option-value]').forEach(button => {
       button.addEventListener('click', function() {
         handleButtonClick(this);
       });
     });
   }
 
   // Note: Color option button clicks are handled in product-item-options.liquid
   // which dispatches the quickAddOpened event. We only listen for that event here.
   // This file's click handler is only for non-color-option quick-add buttons.

   // Intercept fetch/XMLHttpRequest to monitor theme.js's actual requests
   // This helps us see what handle theme.js actually uses
   DEBUG.log('=== SETTING UP INTERCEPTORS ===');
   const originalFetch = window.fetch;
   const originalXHROpen = XMLHttpRequest.prototype.open;
   const originalXHRSend = XMLHttpRequest.prototype.send;
   DEBUG.log('Interceptors initialized');
   
   // Intercept fetch requests
   window.fetch = function(...args) {
     const url = args[0];
     if (typeof url === 'string' && url.includes('/products/') && url.includes('section_id=quick-add-product')) {
       const handleMatch = url.match(/\/products\/([^\/\?]+)/);
       if (handleMatch) {
         const actualHandle = decodeURIComponent(handleMatch[1]);
         DEBUG.log('=== THEME.JS FETCH REQUEST INTERCEPTED ===');
         DEBUG.log('Actual handle used by theme.js:', actualHandle);
         DEBUG.log('Expected handle (targetProductHandle):', targetProductHandle);
         DEBUG.log('URL:', url);
         if (targetProductHandle && actualHandle !== targetProductHandle) {
           DEBUG.error('❌ MISMATCH! Theme.js is using wrong handle!');
           DEBUG.error('  Expected:', targetProductHandle);
           DEBUG.error('  Actual:', actualHandle);
         } else if (targetProductHandle) {
           DEBUG.log('✅ Handle matches!');
         }
         DEBUG.log('==========================================');
       }
     }
     return originalFetch.apply(this, args);
   };
   
   // Intercept XMLHttpRequest
   XMLHttpRequest.prototype.open = function(...args) {
     const method = args[0];
     const url = args[1];
     if (typeof url === 'string' && url.includes('/products/') && url.includes('section_id=quick-add-product')) {
       const handleMatch = url.match(/\/products\/([^\/\?]+)/);
       if (handleMatch) {
         const actualHandle = decodeURIComponent(handleMatch[1]);
         DEBUG.log('=== THEME.JS XHR REQUEST INTERCEPTED ===');
         DEBUG.log('Actual handle used by theme.js:', actualHandle);
         DEBUG.log('Expected handle (targetProductHandle):', targetProductHandle);
         DEBUG.log('URL:', url);
         if (targetProductHandle && actualHandle !== targetProductHandle) {
           DEBUG.error('❌ MISMATCH! Theme.js is using wrong handle!');
           DEBUG.error('  Expected:', targetProductHandle);
           DEBUG.error('  Actual:', actualHandle);
         } else if (targetProductHandle) {
           DEBUG.log('✅ Handle matches!');
         }
         DEBUG.log('==========================================');
       }
     }
     return originalXHROpen.apply(this, args);
   };

   // Register event listeners immediately when script loads
   // This ensures they're ready before any events are dispatched
   DEBUG.log('=== REGISTERING EVENT LISTENERS ===');
   DEBUG.log('Script loaded, registering quickAddOpened event listener...');
   
   // Listen for quickAddOpened event (dispatched from product-item-options.liquid)
   document.addEventListener('quickAddOpened', function(event) {
     DEBUG.log('=== QUICK ADD OPENED EVENT RECEIVED ===');
     DEBUG.log('Quick add opened event received:', event);
     DEBUG.log('Event type:', event.type);
     DEBUG.log('Event detail:', event.detail);
     DEBUG.log('Event detail properties:', {
       productId: event.detail?.productId,
       productHandle: event.detail?.productHandle,
       variantId: event.detail?.variantId,
       colorValue: event.detail?.colorValue,
       isFromColorOption: event.detail?.isFromColorOption,
       isFromFCR: event.detail?.isFromFCR
     });
     
     // Skip if this is from featured-collection-row on product pages
     // Let the new independent JS handle it
     // Check if we're on a product page
     const isProductPage = document.body.classList.contains('template-product') || 
                           window.location.pathname.includes('/products/');
     
     if (event.detail && event.detail.isFromFCR === true && isProductPage) {
       DEBUG.log('⚠️ Skipping: This event is from featured-collection-row on product page, will be handled by al-product-page-featured-collection-quick-add.js');
       return;
     }
     
     // If isFromFCR but not on product page, continue processing (for homepage/other pages)
     if (event.detail && event.detail.isFromFCR === true && !isProductPage) {
       DEBUG.log('✅ Processing FCR event on non-product page (homepage/other pages)');
     }
     
     // Store the target variant ID and product handle for preselection
     if (event.detail && event.detail.variantId) {
       targetVariantId = String(event.detail.variantId); // Ensure string type
       targetProductHandle = event.detail.productHandle || null;
       targetColorValue = event.detail.colorValue || null; // Store color value as fallback
       DEBUG.log('✅ Target variant ID set to:', targetVariantId);
       DEBUG.log('✅ Target product handle set to:', targetProductHandle);
       DEBUG.log('✅ Target color value set to:', targetColorValue);
       DEBUG.log('Target variant ID type:', typeof targetVariantId);
       DEBUG.log('Target product handle type:', typeof targetProductHandle);
       DEBUG.log('Target color value type:', typeof targetColorValue);
     } else {
       DEBUG.error('❌ No variant ID found in event detail!');
       DEBUG.error('Event detail:', event.detail);
       DEBUG.error('Event detail type:', typeof event.detail);
       DEBUG.error('Event detail keys:', event.detail ? Object.keys(event.detail) : 'null');
     }
     
     // Don't initialize gallery here - wait for quick-add:open event
     // The modal content will be loaded asynchronously, so we need to wait
     DEBUG.log('Waiting for quick-add:open event to initialize gallery...');
   });
   
   DEBUG.log('quickAddOpened event listener registered');
   
   // Listen for quick-add modal open event (dispatched by theme.js)
   document.addEventListener('quick-add:open', function(event) {
     DEBUG.log('=== QUICK ADD MODAL OPENED ===');
     DEBUG.log('Quick add modal opened event received');
     DEBUG.log('Event detail:', event.detail);
     
     // Try to extract product handle from productContent HTML
     let modalProductHandle = null;
     if (event.detail && event.detail.productContent) {
       const htmlContent = event.detail.productContent;
       // Try to find product handle in the HTML content
       const handleMatch = htmlContent.match(/data-product-handle=["']([^"']+)["']/i);
       if (handleMatch) {
         modalProductHandle = handleMatch[1];
         DEBUG.log('Product handle extracted from productContent:', modalProductHandle);
       }
       
       // Also try to find in href links
       if (!modalProductHandle) {
         const hrefMatch = htmlContent.match(/href=["'][^"']*\/products\/([^\/\?"']+)/i);
         if (hrefMatch) {
           modalProductHandle = hrefMatch[1];
           DEBUG.log('Product handle extracted from href:', modalProductHandle);
         }
       }
     }
     
     // Store the modal product handle for comparison
     if (modalProductHandle) {
       DEBUG.log('Modal product handle:', modalProductHandle);
       DEBUG.log('Target product handle:', targetProductHandle);
       if (targetProductHandle && modalProductHandle !== targetProductHandle) {
         DEBUG.warn('⚠️ Product handle mismatch!');
         DEBUG.warn('  Expected:', targetProductHandle);
         DEBUG.warn('  Found in modal:', modalProductHandle);
         DEBUG.warn('  The modal loaded the wrong product!');
       }
     }
     
     // Wait for modal content to be inserted into DOM
     setTimeout(function() {
       DEBUG.log('Initializing gallery after modal opened (500ms delay)...');
       DEBUG.log('Current targetVariantId:', targetVariantId);
       DEBUG.log('Current targetProductHandle:', targetProductHandle);
       DEBUG.log('Modal product handle:', modalProductHandle);
       // Clear cached elements to force re-initialization
       cachedElements.mainImage = null;
       cachedElements.variantContainer = null;
       cachedElements.variantJson = null;
       initializeGallery();
     }, 500);
   });
   
   DEBUG.log('quick-add:open event listener registered');
   DEBUG.log('=== EVENT LISTENERS REGISTERED ===');
 
   document.addEventListener('DOMContentLoaded', function() {
     DEBUG.log('DOMContentLoaded fired');
     initializeGallery();
   });
 
   const debouncedInitialize = debounce(initializeGallery, 250);
   const observer = new MutationObserver(function(mutations) {
     mutations.forEach(function(mutation) {
       if (mutation.addedNodes.length) {
         DEBUG.log('DOM mutation detected, reinitializing gallery...');
         debouncedInitialize();
       }
     });
   });
 
   observer.observe(document.body, { 
     childList: true, 
     subtree: true 
   });
 
   // Enable debug mode by setting DEBUG.enabled = true in browser console
   window.quickAddDebug = {
     enable: function() {
       DEBUG.enabled = true;
       console.log('[Quick Add Debug] Debug mode enabled');
     },
     disable: function() {
       DEBUG.enabled = false;
       console.log('[Quick Add Debug] Debug mode disabled');
     }
   };